export default {
  title: 'Zaproszenie do grupy treningowej',
  type: 'object',
  properties: {
    email: {
      title: 'schema.invite.email',
      format: 'email',
      type: 'string',
      fieldRequired: true
    },
    teamId: {
      type: 'number',
      fieldRequired: true
    }
  }
};
